module.exports = __webpack_public_path__ + "static/img/girl.a242c6b2.png";